var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import T from 'prop-types';
import { DuplicateDocumentDialog } from 'app/domains/documents';
import { CreateFolderDialog, MoveDialog, MoveEntryConfirmation, RenameEntryDialog, DeleteFolderDialog, DeleteDocumentDialog, UploadDocumentDialog, } from 'app/domains/filesystem';
import { UploadDocumentsDialog } from 'app/domains/upload';
import { EntryKind } from 'shared/domains/apollo/generated/types';
function Dialog(_a) {
    var { action, onCreated, onDuplicated, onRenamed, onDeleted, onDocumentsUploaded } = _a, restProps = __rest(_a, ["action", "onCreated", "onDuplicated", "onRenamed", "onDeleted", "onDocumentsUploaded"]);
    const { name, type, payload } = action || {};
    switch ([name, type].filter(Boolean).join(':')) {
        case 'CREATE:UPLOAD_FOLDER':
            return <UploadDocumentsDialog {...restProps} onCompleted={onDocumentsUploaded}/>;
        case `CREATE:${EntryKind.Folder}`:
            return <CreateFolderDialog {...restProps} onCreated={onCreated}/>;
        case `CREATE:${EntryKind.Document}`:
            return <UploadDocumentDialog {...restProps} files={payload.files} onCreated={onCreated}/>;
        case `DUPLICATE:${EntryKind.Document}`:
            return <DuplicateDocumentDialog {...restProps} id={payload.id} onDuplicated={onDuplicated}/>;
        case `RENAME:${EntryKind.Folder}`:
        case `RENAME:${EntryKind.Document}`:
            return <RenameEntryDialog {...restProps} payload={payload} type={type} onRenamed={onRenamed}/>;
        case `DELETE:${EntryKind.Folder}`:
            return <DeleteFolderDialog {...restProps} payload={payload} onDeleted={onDeleted}/>;
        case `DELETE:${EntryKind.Document}`:
            return <DeleteDocumentDialog {...restProps} id={payload.id} onDeleted={onDeleted}/>;
        case `MOVE:${EntryKind.Folder}`:
        case `MOVE:${EntryKind.Document}`:
            return <MoveDialog {...restProps} payload={payload} type={type}/>;
        case `QUICK_MOVE:${EntryKind.Folder}`:
        case `QUICK_MOVE:${EntryKind.Document}`:
            return (<MoveEntryConfirmation {...restProps} sourceId={payload.sourceId} targetId={payload.targetId} type={type}/>);
        default:
            return null;
    }
}
Dialog.propTypes = {
    action: T.shape({
        name: T.oneOf(['CREATE', 'DELETE', 'DUPLICATE', 'RENAME', 'MOVE', 'QUICK_MOVE', 'ADD_REMINDER', 'EDIT_ACCESS']),
        type: T.oneOf([EntryKind.Folder, EntryKind.Document, 'UPLOAD_FOLDER']),
        // eslint-disable-next-line react/forbid-prop-types
        payload: T.object,
    }),
    onCreated: T.func,
    onDuplicated: T.func,
    onRenamed: T.func,
    onDeleted: T.func,
    onDocumentsUploaded: T.func,
};
Dialog.defaultProps = {
    action: undefined,
    onCreated: undefined,
    onDuplicated: undefined,
    onRenamed: undefined,
    onDeleted: undefined,
    onDocumentsUploaded: undefined,
};
export default Dialog;
